<template lang="pug">
  .box
    .banner
    .body
      .bodyOne
        h3 热线服务
        .one
          img(src="../assets/img/dian.png" alt="")
          .nei
            h4 咨询热线
            span 400-0931-866
            p 速云云服务平台是速云位每个客户精心打造的专业服务平台，致力于为客户提供从签约、实施、到售后全程业务服务，快速响应客户的服务需求。
      .bodyTwo
        h3 服务内容
        .two
          h4 问题处理
          ul
            li
              p 客户在线提交问题，由服务工程师为客户提供全方位的产品技术支持与服务。
            li
              p 提供智能客服机器人7*24小时自助服务，在线问答。
            li(style="margin-right:0;")
              p 在线会话、远程控制、远程演示、文件传输，为客户提供远程系统维护支持。
        .two
          h4 持续服务
          ul
            li
              p 提供新版本推荐、版本升级服务、补丁安装信息和产品文档寄送服务。
            li
              p 提供定期巡检服务，发现客户系统使用过程中的问题，在云服务平台形成巡检报告供查询。
            li(style="margin-right:0;")
              p 设计支持服务，提供节庆日系统登陆页及主页主题资源包。
        .two
          h4 自助学习
          ul
            li
              p 社区囊括最新知识、大神分享、福利活动等，论坛三大讨论区助您更好维护系统稳定。
            li
              p 提供专业的系统运维培训、二次开发培训和知识管理系统工程师认证培训。
            li(style="margin-right:0;")
              p 提供系统自助服务：FAQ库，知识库，案例库、在线课堂等，帮助客户自行查找解决方案。
            li(style="margin:10px 0 20px;")
              p 每年分区域提供老客户技术沙龙交流，传递产品新功能及解决方案，常见问题处理。
</template>

<script>
export default {
  data () {
    return {
    }
  },
  created () {
    this.$store.commit('changeNav', 6)
  },
  methods: {
  },
  mounted () {
    document.title = '速云官网'
  }
}
</script>

<style lang="less" scoped>
  .banner{
    width: 100%;
    height: 386px;
    background-image: url(../assets/img/bannerF.jpg);
    background-size: cover;
    background-position: 50%;
  }
  .body{
    .bodyOne{
      h3{
        font-size: 34px;
        text-align: center;
        font-weight: 400;
        margin: 20px;
      }
      .one{
        overflow: hidden;
        width: 80%;
        margin: 0 auto;
        img{
          width: 48%;
          float: left;
        }
        .nei{
          width: 48%;
          float: right;
          h4{
            font-size: 28px;
            margin: 20px 0;
          }
          span{
            font-size: 32px;
            color: #409fee;
          }
          p{
            margin-top: 20px;
            line-height: 26px;
          }
        }
      }
    }
    .bodyTwo{
      h3{
        font-size: 34px;
        text-align: center;
        font-weight: 400;
        margin: 20px;
      }
      .two{
        width: 80%;
        margin: 0 auto;
        h4{
          font-size: 28px;          margin: 20px 0;
        }
      }
      ul{
        overflow: hidden;
        li{
          float: left;
          width: 25%;
          padding: 20px;
          height: 63px;
          border: 1px solid #ccc;
          text-align: justify;
          margin-right: 70px;
        }
        li:hover{
          background-color: rgba(0, 0, 0, .3);
          color: #fff;
        }
      }
    }
  }
</style>
